<div layout="column" ui-view>
  <div layout="row" layout-align="space-around center" layout-padding>
    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"
          layout-align="space-around center">
      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"
                       md-search-text="vm.searchText"
                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"
                       md-item-text="townhall.name"
                       md-require-match
                       md-min-length="0"
                       ng-required="true"
                       ng-disabled="vm.townhalls.length === 1"
                       md-clear-button="true"
                       md-floating-label="{{'SELECT_TOWNHALL_TO_FILTER' | translate}}" style="padding-top: 15px">
        <md-item-template>
          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>
        </md-item-template>
        <md-not-found>
          {{'RESULT_NOT_FOUND' | translate}}
        </md-not-found>
      </md-autocomplete>
      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.initDate"
                     md-placeholder="{{'INI_DATE' | translate}}" md-max-date="vm.endDate"></md-datepicker>
      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"
                     md-placeholder="{{'END_DATE' | translate}}" md-min-date="vm.initDate" md-max-date="vm.today"
                     ng-disabled="vm.initDate === null"></md-datepicker>
      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{'FILTER' |
        translate}}
      </md-button>
    </form>
  </div>
  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">
    <md-card flex-gt-md="95" flex="100">

      <div class="md-whiteframe-1dp" flex>
        <md-card-header layout-padding>
          <md-card-header-text>
            <span class="md-headline">{{'CANCELLATIONS.CANCELED_MATCHES' | translate}}</span>
          </md-card-header-text>
        </md-card-header>
      </div>
      <md-card-content>
        <span class="md-body-2" ng-hide="vm.showList">{{'CANCELLATIONS.NOT_FOUND_CANCELLATIONS' | translate}}</span>
        <md-table-container ng-if="vm.showList">
          <table md-table md-row-select="false" ng-model="vm.selected" md-progress="vm.promiseMatches">
            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">
            <tr md-row>
              <th md-column md-order-by="originalDate">{{ 'CANCELLATIONS.MATCH_DATE' | translate}}</th>
              <th md-column md-order-by="originalTime">{{ 'CANCELLATIONS.MATCH_TIME' | translate}}</th>
              <th md-column md-order-by="championship">{{ 'CHAMPIONSHIPS.CHAMPIONSHIP' | translate}}</th>
              <th md-column md-order-by="localTeam">{{ 'CHAMPIONSHIPS.LOCAL_TEAM' | translate}}</th>
              <th md-column md-order-by="visitorTeam">{{ 'CHAMPIONSHIPS.VISITOR_TEAM' | translate}}</th>
              <th md-column md-order-by="type">{{ 'CANCELLATIONS.TYPE' | translate}}</th>
              <th md-column md-order-by="resolved">{{ 'CANCELLATIONS.STATE' | translate}}</th>
              <th md-column>
                <div flex layout="row" layout-align="center center">
                  {{'ACTIONS' | translate}}
                </div>
              </th>
            </tr>
            </thead>
            <tbody md-body>
            <tr md-row ng-repeat="match in vm.matches">
              <td md-cell>{{match.date}}</td>
              <td md-cell>{{match.time || "--:--"}}</td>
              <td md-cell>{{match.championship}}</td>
              <td md-cell>{{match.localTeam.name}}</td>
              <td md-cell>{{match.visitorTeam.name}}</td>
              <td md-cell>{{'CANCELLATIONS.TYPES.' + match.lastCancellation.type.name | translate}}</td>
              <td md-cell ng-if="match.lastCancellation.resolved">{{'CANCELLATIONS.RESOLVED' | translate}}</td>
              <td md-cell ng-if="!match.lastCancellation.resolved">{{'CANCELLATIONS.UNRESOLVED' | translate}}</td>
              <td md-cell>
                <div flex layout="row" layout-align="center center">
                  <md-button class="md-icon-button" aria-label="edit" ng-if="vm.showEditButton(match)"
                             ng-click="vm.editCancellation(match)">
                    <md-tooltip md-direction="left" md-delay="50">{{'EDIT' | translate}}</md-tooltip>
                    <md-icon>mode_edit</md-icon>
                  </md-button>
                  <md-button class="md-icon-button" aria-label="edit" ng-if="vm.showPostponeButton(match)"
                             ng-click="vm.postponeCancellation(match)">
                    <md-tooltip md-direction="right" md-delay="50">{{'POSTPONEMENTS.POSTPONE' | translate}}</md-tooltip>
                    <md-icon>event_busy</md-icon>
                  </md-button>
                  <md-switch ng-if="vm.showResolveSwitch(match)" ng-model="match.lastCancellation.resolved"
                             ng-change="vm.updateMatchState(match)"></md-switch>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </md-table-container>
        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"
                             md-label="{{vm.paginationLabel}}" md-page-select="true"
                             md-on-paginate="vm.getNewPage" ng-if="vm.showList"></md-table-pagination>
      </md-card-content>
    </md-card>
  </div>
</div>
